/**
 * Translation dictionaries for all supported languages
 */

import { translationsDe } from './translations-de';
import { translationsEn } from './translations-en';
import { translationsEs } from './translations-es';
import { translationsFr } from './translations-fr';
import { Translations, Language } from './types';

export const translations: Record<Language, Translations> = {
  en: translationsEn,
  fr: translationsFr,
  de: translationsDe,
  es: translationsEs,
};
